import { render, staticRenderFns } from "./admin-organization-setup-wizard.vue?vue&type=template&id=2729d4a0&scoped=true&"
import script from "./admin-organization-setup-wizard.vue?vue&type=script&lang=js&"
export * from "./admin-organization-setup-wizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2729d4a0",
  null
  
)

export default component.exports